export const SET_BUSINESS = "SET_BUSINESS";
export const UPDATE_BUSINESS = "UPDATE_BUSINESS";
export const SET_LANDING_PAGE = "SET_LANDING_PAGE";
export const SET_LANDING_PAGES = "SET_LANDING_PAGES";
export const ADD_LANDING_PAGE = "ADD_LANDING_PAGE";
export const UPDATE_LANDING_PAGE = "UPDATE_LANDING_PAGE";
export const SET_ECOMMERCE = "SET_ECOMMERCE";
export const SET_EMBED_FORM = "SET_EMBED_FORM";
export const SET_EMBED_FORMS = "SET_EMBED_FORMS";
export const ADD_EMBED_FORM = "ADD_EMBED_FORM";
export const UPDATE_EMBED_FORM = "UPDATE_EMBED_FORM";
export const SET_CUSTOM_FORM = "SET_CUSTOM_FORM";
export const SET_CUSTOM_FORMS = "SET_CUSTOM_FORMS";
export const ADD_CUSTOM_FORM = "ADD_CUSTOM_FORM";
export const UPDATE_CUSTOM_FORM = "UPDATE_CUSTOM_FORM";
export const SET_SPECIAL_FIELDS = "SET_SPECIAL_FIELDS";
export const ADD_SPECIAL_FIELD = "ADD_SPECIAL_FIELD";
export const UPDATE_SPECIAL_FIELD = "UPDATE_SPECIAL_FIELD";
export const SET_FAQ = "SET_FAQ";
export const SET_FAQS = "SET_FAQS";
export const ADD_FAQ = "ADD_FAQ";
export const UPDATE_FAQ = "UPDATE_FAQ";
export const DELETE_FAQ = "DELETE_FAQ";
